import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Injectable()
export class EventService {
  private events: {
    [eventName: string]: Subject<any>;
  };

  constructor() {
    this.events = {};
  }

  /**
   * Use below to subscribe any channel by using an event name
   * @param eventName an eventName that you can subscribe on.
   * @returns a referecne to the subscription that can be used to unsubscribe
   */
  public subscribe(eventName: string, callback: (data: any) => void): Subscription {
    if (this.events[eventName] === undefined) {
      this.events[eventName] = new Subject<any>();
    }

    return this.events[eventName].asObservable().subscribe(callback);
  }

  /**
   * Use below to subscribe any channel by using an event name
   * @param eventName an event name that you want to listen on
   * @param eventObject event object that will be sent to you from publisher.
   */
  public publish(eventName: string, eventObject?: any) {
    if (!eventName) {
      throw new Error('[ EventService ] => eventName is required to publish a message');
    }

    const subject: Subject<any> = this.events[eventName];

    // if nobody listens to an event, we will not even publish it
    if (subject) {
      if (eventName === 'TAKE_A_TOUR_CLAIMS') {
        //console.log('*** pubished!!');
      }
      subject.next(eventObject);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/event.service.ts